import React from 'react';
import { Building2, CheckCircle2 } from 'lucide-react';
import Navbar from '@/components/landing/Navbar';
import Footer from '@/components/landing/Footer';
import SEO from '@/components/SEO';

const AboutUs = () => {
  const vasItems = [
    'WhatsApp Integration - Real-time order tracking and customer updates.',
    'Branded Package - Customized packaging experience that strengthens your brand identity.',
    'Branded Tracking - Personalized tracking pages for a consistent post-purchase brand experience.',
    'Last-Mile Support - Faster and more reliable deliveries.',
    'Multi-Channel Integration - Direct connections to Shopify, WooCommerce, Amazon, and other platforms.',
    'SmartOps for RTO Tracking - Prevent losses by verifying return shipments.',
    'Automated Allocation Engine - AI-driven smart routing for cost-effective shipping.',
    'Real-Time Tracking Dashboard - Full visibility into shipments at every stage.'
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="About Boxd Logistics"
        description="Learn about Boxd Logistics - our mission to simplify shipping with a technology-first logistics platform built for modern eCommerce brands."
        keywords="about boxd logistics, ecommerce shipping company, logistics saas india, shipping aggregator"
        canonical="https://boxdlogistics.in/about"
      />
      <Navbar />

      <section className="relative pt-32 pb-20 px-4 bg-gradient-to-br from-blue-50 via-white to-blue-50 overflow-hidden">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(rgba(59, 130, 246, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(59, 130, 246, 0.03) 1px, transparent 1px)',
            backgroundSize: '48px 48px'
          }}
        ></div>

        <div className="relative max-w-5xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-700 to-blue-800 rounded-full mb-6">
            <Building2 className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-4">About Us</h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            At Boxd Logistics, we are revolutionizing logistics with a shipping aggregator platform designed to simplify, optimize, and enhance shipping operations for businesses of all sizes.
          </p>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="max-w-5xl mx-auto space-y-8">
          <div className="rounded-2xl border border-gray-200 p-8 bg-white shadow-sm">
            <p className="text-gray-700 leading-relaxed">
              Launched in <strong>December 2024</strong>, our company combines deep eCommerce logistics expertise with seamless multi-courier partner integration, enabling businesses to access competitive shipping rates and reliable services from leading carriers like <strong>Bluedart, Delhivery, Ekart, Shadowfax, XpressBees, DHL, Blitz, Pickndel, DTDC</strong>, and more.
            </p>
          </div>

          <div className="rounded-2xl border border-gray-200 bg-gradient-to-br from-white to-blue-50/30 p-8 shadow-sm">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
              Value-Added Services (VAS)
            </h2>
            <div className="space-y-4">
              {vasItems.map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-emerald-600 mt-0.5" />
                  <p className="text-gray-700 leading-relaxed">{item}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-2xl border border-blue-200 bg-blue-50/50 p-8 shadow-sm">
            <p className="text-gray-800 text-lg leading-relaxed font-medium">
              We are committed to innovation, efficiency, and customer satisfaction - making logistics smarter, faster, and hassle-free for businesses. At Boxd Logistics, we do not just move shipments; we power growth.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutUs;
